import React from 'react';
import { Order } from '@features/siteStatusV2/types';
import { isFiberPrepOrder, isFtthOrder } from '@features/siteStatusV2/utils';
import isAdductionOrder from '@features/siteStatusV2/utils/guards/isAdductionOrder';

import { FiberPrepOrderDetails } from '../fiber-prep-order-details';
import { FtthOrderDetails } from '../ftth-order-details';
import { AdductionOrderDetails } from '../adduction-order-details';

interface OrderDetailsSwitcherProps {
  order?: Order;
}

const OrderDetailsSwitcher: React.FC<OrderDetailsSwitcherProps> = ({ order }) => {
  if (isFtthOrder(order)) {
    return <FtthOrderDetails order={order} />;
  }

  if (isFiberPrepOrder(order)) {
    return <FiberPrepOrderDetails order={order} />;
  }

  if (isAdductionOrder(order)) {
    return <AdductionOrderDetails order={order} />;
  }

  return null;
};

export default OrderDetailsSwitcher;
